export const ACCESS_LOG_REQUEST = 'ACCESS_LOG_REQUEST';
export const ACCESS_LOG_SUCCESS = 'ACCESS_LOG_SUCCESS';
export const ACCESS_LOG_FAILURE = 'ACCESS_LOG_FAILURE';
export const ACCESS_LOG_PARTIAL = 'ACCESS_LOG_PARTIAL';

export const ACCESS_LOG_FILTERS = 'ACCESS_LOG_FILTERS';

export const ACCESS_LOG_PATH_CHANGED = 'ACCESS_LOG_PATH_CHANGED';
export const ACCESS_LOG_RESET_FILTERS = 'ACCESS_LOG_RESET_FILTERS';
